<h2 mat-dialog-title>{{title | translate}}</h2>
<mat-dialog-content class="mat-typography">
  {{message | translate}}
</mat-dialog-content>
@if (!hideActions) {
<mat-dialog-actions align="end">
  @if (showConfirm) {
    <button mat-button (click)="onCancelClick()">{{cancelButtonText | translate}}</button>
    <button mat-raised-button color="primary" cdkFocusInitial (click)="onConfirmClick()">{{confirmButtonText | translate}}</button>
  } @else {
    <button mat-raised-button color="primary" cdkFocusInitial (click)="onConfirmClick()">{{cancelButtonText | translate}}</button>
  }
</mat-dialog-actions>
}